module.exports = __webpack_public_path__ + "static/media/15.77d396b9.JPG";